import instance from "./index";

const normalizeGlobalRole = (role) => ({
  ...role,
  roleId:
    role?.roleId ??
    role?.RoleId ??
    role?.globalRolesId ??
    role?.GlobalRolesId ??
    role?.globalRoleId ??
    role?.GlobalRoleId ??
    role?.id ??
    role?.Id ??
    null,
  roleName: role?.roleName ?? role?.RoleName ?? role?.name ?? "",
  level: role?.level ?? role?.Level ?? null,
});

export const getAllGlobalRoles = async () => {
  try {
    const response = await instance.get("/globalRoles/getAll");
    const data = response?.data;
    const list = Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
        ? data.data
        : [];

    return list.map(normalizeGlobalRole);
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to load global roles";
    throw new Error(message);
  }
};

export const getGlobalRoleById = async (roleId) => {
  if (roleId === undefined || roleId === null || roleId === "") {
    throw new Error("Role id is required");
  }

  try {
    const response = await instance.get(`/globalRoles/getById/${roleId}`);
    const data = response?.data?.data ?? response?.data;
    return normalizeGlobalRole(data);
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to load global role";
    throw new Error(message);
  }
};

export const updateGlobalRole = async ({ roleId, roleName, level = 1 }) => {
  const trimmedName = String(roleName ?? "").trim();

  if (roleId === undefined || roleId === null || roleId === "") {
    throw new Error("Role id is required");
  }

  if (!trimmedName) {
    throw new Error("Role name is required");
  }

  try {
    const response = await instance.put(
      `/globalRoles/updateProjectRoles/${roleId}`,
      {
        roleName: trimmedName,
        level,
      },
    );
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to update global role";
    throw new Error(message);
  }
};

export const createGlobalRole = async ({ roleName, level = 1 }) => {
  const trimmedName = String(roleName ?? "").trim();

  if (!trimmedName) {
    throw new Error("Role name is required");
  }

  try {
    const response = await instance.post("/globalRoles", {
      roleName: trimmedName,
      level,
    });
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to create global role";
    throw new Error(message);
  }
};
